import React, { useContext, useState,useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards";
import ProductsTableComponent from "../../components/tables/ProductsTableComponent";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { PaginationComponent } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import drafts from "../../assets/data/drafts.json";
import { DraftTableComponent } from "../../components/tables";
import axios from "axios";
export default function DraftList() {

    const AuthToken = localStorage.getItem("AuthUser");
    const [data,setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
          try {
            axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
            const response = await axios.get(
              process.env.REACT_APP_API_URL + "/draft-list"
            );
            setData(response.data.peoples);
           
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        fetchData();
      }, []);
    const { t, n } = useContext(TranslatorContext)
    
    const floats = [
        { "title": "Pending Families", "digit": 547, "icon": "donut_large", "variant": "lg purple" },
        { "title": "Requested Families", "digit": 249, "icon": "widgets", "variant": "lg yellow" }, 
        { "title": "Approved Families", "digit": 605, "icon": "approval", "variant": "lg blue" },
        { "title": "Rescued Families", "digit": 1050, "icon": "sports_score", "variant": "lg green" }
      
    ]
    const mappedData = data.map((person) => ({
        id: person.id || "",
        fsf_id: person.f_number || "",
        beneficiary_cnic: person.cnic || "",
        beneficiary_name: person.beneficiary_name || "",
        partner_name: person.identifier?.name || "", // Assuming the same name
        organization_church: person.identifier?.org || "",
       
        total_loan_amount: person.loan?.est_loan_amount || 0,
        assesment_date: person.assesment_date || "",
       
        status: "Tested", // Static value, replace if dynamic
        action: {
          edit: "edit",
          delete: "delete",
          view: "visibility",
        },
      }));
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{'Draft List'}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link" style={{color:"#077834"}}>{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link" style={{color:"#077834"}}>{t('Families')}</Link></li>
                                <li className="mc-breadcrumb-item">{'Draft List'}</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {/* {floats.map((float, index) => (
                    <Col key={ index } sm={6} lg={3}>
                        <FloatCardComponent 
                            variant={ float.variant }
                            digit={n(float.digit)}
                            title={t(float.title)}
                            icon={ float.icon }
                        />
                    </Col>
                ))} */}
                <Col xl={12}>
                    <div className="mc-card">
                        <Row>
                           
                            <Col xl={12}>
                                <DraftTableComponent 
                                    thead={ drafts.thead } 
                                    tbody={ mappedData } 
                                />
                                {/* <PaginationComponent /> */}
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}
